import { Flex, Text, TextInput } from "@mantine/core";
import { Controller } from "react-hook-form";

const RestSection = ({ control }) => {
  return (
    <Flex direction="column" gap="sm">
      <Text size="sm" fw={600}>
        REST Configuration
      </Text>
      <Flex>
        <Controller
          name="rest.from"
          control={control}
          render={({ field }) => (
            <TextInput
              {...field}
              value={field.value ?? ""}
              label="From"
              placeholder="support@infinno.com"
              w={220}
            />
          )}
        />
      </Flex>
    </Flex>
  );
};

export default RestSection;
